// extracted by mini-css-extract-plugin
module.exports = {"festivalRules":"styles_festivalRules__16uCn","ignore-list-style":"styles_ignore-list-style__62FnW","text-center":"styles_text-center__1yWyz"};